import { useModal } from "@sablier/v2-contexts";
import { modals } from "~/client/constants";

export default function useModalPermissions() {
  return useModal<never>(modals.permissions);
}
